import { render, staticRenderFns } from "./CategoryProducts.vue?vue&type=template&id=536941d1"
import script from "./CategoryProducts.vue?vue&type=script&lang=js"
export * from "./CategoryProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmContentCard: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmContentCard.vue').default,ProductListCard: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Product/List/Card.vue').default,TlmContainer: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmContainer.vue').default,TlmSection: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmSection.vue').default})
